import { Map as map } from 'immutable';
const C = require("../constants");

function ModalOtherSalesDialogReducer(state = map(), action) {
    switch (action.type) {
        case C.OTHER_SALES_MODAL:
            return action.modal;
        default:
            return state;
    }
}

export default ModalOtherSalesDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/ModalOtherSalesDialogReducer.js